import { FC, ReactNode } from 'react';
import { List } from '@mui/material';

interface Props {
  children?: ReactNode;
}

const SidebarNav: FC<Props> = ({ children }) => {
  return (
    <List
      component="nav"
      sx={{ py: 0 }}
    >
      {children}
    </List>
  );
};

export default SidebarNav;
